/**
 * Web: exchange PKCE codes / hash tokens on routes other than dedicated callback screens.
 * Email confirmation redirects to /app/ with tokens; detectSessionInUrl is off on web.
 */

import { useEffect, useRef } from 'react'
import { Platform } from 'react-native'
import { establishWebAuthSessionFromCallbackUrl } from '../helpers/authWebCallbackSession.helper'

const WEB_AUTH_BOOTSTRAP_SKIP_SEGMENTS = new Set([
  'oauth-native-callback',
])

function shouldBootstrapWebAuthFromUrl(pathname: string, href: string): boolean {
  const segments = pathname.split('/').filter(Boolean)
  if (segments.some((segment) => WEB_AUTH_BOOTSTRAP_SKIP_SEGMENTS.has(segment))) {
    return false
  }
  return href.includes('code=') || href.includes('access_token=')
}

export function useWebAuthUrlSessionBootstrap(pathname: string): void {
  const hasStarted = useRef(false)

  useEffect(() => {
    if (Platform.OS !== 'web' || typeof window === 'undefined') return
    if (hasStarted.current) return

    const href = window.location.href
    if (!shouldBootstrapWebAuthFromUrl(pathname, href)) return

    hasStarted.current = true
    void establishWebAuthSessionFromCallbackUrl(href)
  }, [pathname])
}
